"use strict";
/*
 *
 *  When using constants from this file, prefer to use enums. Constants are only for backward compatibility.
 *
 * */
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectTypes = exports.ReferralConfigurations = exports.LivePointerSupportedOS = exports.SalesforceEnvironmentTypes = exports.ExternalPackageType = exports.salesforceAccountType = exports.PendingAccountTypes = exports.PendingAccountStatus = exports.SalesForceAuthMethod = exports.postMessageMethod = exports.emailSendBy = exports.emailDomainTypes = exports.emailDomainStatus = exports.fieldServicesTypes = exports.liveSdkAppIDs = exports.QuickLaunchDefaultBrowserTypes = exports.CoBrowserModes = exports.bulkSharingByEmailModes = exports.ACCOUNT_TYPES = exports.EmailFromType = exports.speedtestUrl = exports.MediaTypes = exports.onboardingTools = exports.CoBrowserControlsEnum = exports.CoBrowserModesEnum = exports.QuickLaunchDefaultBrowserEnum = exports.bulkEmailSharingModeEnum = exports.screenShareTypeEnum = exports.hostingAppEnum = exports.projectTypes = exports.supportedThemes = exports.accountTypes = exports.RolesConstant = void 0;
var RolesConstant;
(function (RolesConstant) {
    RolesConstant["SYSADMIN"] = "sysadmin";
    RolesConstant["SUPERADMIN"] = "superAdmin";
    RolesConstant["ADMIN"] = "admin";
    RolesConstant["REPORTING_ADMIN"] = "reportingAdmin";
    RolesConstant["USERS_ADMIN"] = "usersAdmin";
    RolesConstant["MANAGER"] = "manager";
    RolesConstant["TECHNICIAN"] = "technician";
    RolesConstant["TECHNICIAN_SUPERVISOR"] = "technicianSupervisor";
    RolesConstant["FIELD_SERVICES_ENGINEER"] = "fieldServicesEngineer";
    RolesConstant["GUEST_OBSERVER"] = "guestObserver";
    RolesConstant["KNOWLEDGE_EXPERT"] = "knowledgeExpert";
    RolesConstant["USER"] = "user";
    RolesConstant["LITE_ADMIN"] = "liteAdmin";
})(RolesConstant = exports.RolesConstant || (exports.RolesConstant = {}));
var accountTypes;
(function (accountTypes) {
    accountTypes["live"] = "live";
    accountTypes["lite"] = "lite";
    accountTypes["liveStarterKit"] = "liveStarterKit";
    accountTypes["liveEssentials"] = "liveEssentials";
    accountTypes["livePro"] = "livePro";
    accountTypes["liveEnterprise"] = "liveEnterprise";
    accountTypes["eve"] = "eve";
    accountTypes["liveAndEve"] = "liveAndEve";
    accountTypes["bcp"] = "bcp";
    accountTypes["tsve"] = "TSVE";
})(accountTypes = exports.accountTypes || (exports.accountTypes = {}));
var supportedThemes;
(function (supportedThemes) {
    supportedThemes["ts"] = "ts";
    supportedThemes["of"] = "of";
    supportedThemes["vgr"] = "vgr";
    supportedThemes["in"] = "in";
    supportedThemes["tl"] = "tl";
    supportedThemes["btf"] = "btf";
    supportedThemes["npt"] = "npt";
    supportedThemes["lgt"] = "lgt";
    supportedThemes["jb"] = "jb";
    supportedThemes["ge"] = "ge";
    supportedThemes["mh"] = "mh";
    supportedThemes["bbb"] = "bbb";
})(supportedThemes = exports.supportedThemes || (exports.supportedThemes = {}));
var projectTypes;
(function (projectTypes) {
    projectTypes["pilot"] = "Pilot";
    projectTypes["production"] = "Production";
    projectTypes["test"] = "Test";
    projectTypes["dormant"] = "Dormant Account";
    projectTypes["demo"] = "Demo";
    projectTypes["lite"] = "Lite";
    projectTypes["exploration"] = "Exploration";
    projectTypes["none"] = "None";
})(projectTypes = exports.projectTypes || (exports.projectTypes = {}));
var hostingAppEnum;
(function (hostingAppEnum) {
    hostingAppEnum["ST"] = "st";
    hostingAppEnum["SA"] = "sa";
    hostingAppEnum["VA"] = "va";
    hostingAppEnum["BT"] = "bt";
})(hostingAppEnum = exports.hostingAppEnum || (exports.hostingAppEnum = {}));
var screenShareTypeEnum;
(function (screenShareTypeEnum) {
    screenShareTypeEnum["SCREEN"] = "screen";
    screenShareTypeEnum["APP_SHARING"] = "appSharing";
    screenShareTypeEnum["VIDEO_APPLICATION"] = "videoApplication";
})(screenShareTypeEnum = exports.screenShareTypeEnum || (exports.screenShareTypeEnum = {}));
var bulkEmailSharingModeEnum;
(function (bulkEmailSharingModeEnum) {
    bulkEmailSharingModeEnum["COPY_TO_CLIPBOARD_AND_EMAIL"] = "copyToClipboardAndEmail";
    bulkEmailSharingModeEnum["DOWNLOAD_AND_EMAIL"] = "downloadAndEmail";
})(bulkEmailSharingModeEnum = exports.bulkEmailSharingModeEnum || (exports.bulkEmailSharingModeEnum = {}));
var QuickLaunchDefaultBrowserEnum;
(function (QuickLaunchDefaultBrowserEnum) {
    QuickLaunchDefaultBrowserEnum["defaultBrowser"] = "defaultBrowser";
    QuickLaunchDefaultBrowserEnum["chrome"] = "chrome";
    QuickLaunchDefaultBrowserEnum["fireFox"] = "firefox";
    QuickLaunchDefaultBrowserEnum["iexplorer"] = "iexplorer";
})(QuickLaunchDefaultBrowserEnum = exports.QuickLaunchDefaultBrowserEnum || (exports.QuickLaunchDefaultBrowserEnum = {}));
var CoBrowserModesEnum;
(function (CoBrowserModesEnum) {
    CoBrowserModesEnum["techSeeProxy"] = "techSeeProxy";
    CoBrowserModesEnum["surfly"] = "surfly";
})(CoBrowserModesEnum = exports.CoBrowserModesEnum || (exports.CoBrowserModesEnum = {}));
var CoBrowserControlsEnum;
(function (CoBrowserControlsEnum) {
    CoBrowserControlsEnum["pause"] = "pause";
    CoBrowserControlsEnum["control"] = "control";
    CoBrowserControlsEnum["url"] = "url";
})(CoBrowserControlsEnum = exports.CoBrowserControlsEnum || (exports.CoBrowserControlsEnum = {}));
// deprecated. we removed helphero, we only use inlinemanual
var onboardingTools;
(function (onboardingTools) {
    onboardingTools["helpHero"] = "HELP_HERO";
    onboardingTools["inlineManual"] = "INLINE_MANUAL";
})(onboardingTools = exports.onboardingTools || (exports.onboardingTools = {}));
var MediaTypes;
(function (MediaTypes) {
    MediaTypes["videoAndAudio"] = "VIDEO_AND_AUDIO";
    MediaTypes["video"] = "VIDEO";
})(MediaTypes = exports.MediaTypes || (exports.MediaTypes = {}));
var speedtestUrl;
(function (speedtestUrl) {
    speedtestUrl["ookla"] = "https://tsrnd.speedtestcustom.com";
})(speedtestUrl = exports.speedtestUrl || (exports.speedtestUrl = {}));
var EmailFromType;
(function (EmailFromType) {
    EmailFromType["DEFAULT"] = "default";
    EmailFromType["CUSTOM"] = "custom";
})(EmailFromType = exports.EmailFromType || (exports.EmailFromType = {}));
exports.ACCOUNT_TYPES = [
    {
        name: 'TechSee Live',
        value: 'live'
    },
    {
        name: 'TechSee Lite',
        value: 'lite'
    },
    {
        name: 'Live Starter Kit',
        value: 'liveStarterKit'
    },
    {
        name: 'Live Essentials',
        value: 'liveEssentials'
    },
    {
        name: 'Live Pro',
        value: 'livePro'
    },
    {
        name: 'Live Enterprise',
        value: 'liveEnterprise'
    },
    {
        name: 'TechSee EVE',
        value: 'eve'
    },
    {
        name: 'Live + EVE',
        value: 'liveAndEve'
    },
    {
        name: 'BCP',
        value: 'bcp'
    },
    {
        name: 'TSVE',
        value: 'TSVE'
    }
];
exports.bulkSharingByEmailModes = [
    { name: 'Copy to Clipboard & Email', value: 'copyToClipboardAndEmail' },
    { name: 'Download & Email', value: 'downloadAndEmail' }
];
exports.CoBrowserModes = [
    { name: 'TechSee Proxy', value: 'techSeeProxy' },
    { name: 'Surfly', value: 'surfly' }
];
exports.QuickLaunchDefaultBrowserTypes = [
    { name: 'Default browser', value: 'defaultBrowser' },
    { name: 'Chrome', value: 'chrome' },
    { name: 'Firefox', value: 'firefox' },
    { name: 'internet explorer', value: 'iexplorer' }
];
exports.liveSdkAppIDs = [
    { value: 'st', name: 'TechSee Self-Install' },
    { value: 'sa', name: 'TechSee Instant Mirroring' },
    { value: 'ofr', name: 'TechSee for Orange France' },
    { value: 'va', name: 'TechSee Video Application' },
    { value: 'bt', name: 'TechSee By Sharing Type' }
];
var fieldServicesTypes;
(function (fieldServicesTypes) {
    fieldServicesTypes["fieldServices"] = "fieldServices1.0";
    fieldServicesTypes["fieldServices2"] = "fieldServices2.0";
    fieldServicesTypes["none"] = "none";
})(fieldServicesTypes = exports.fieldServicesTypes || (exports.fieldServicesTypes = {}));
var emailDomainStatus;
(function (emailDomainStatus) {
    emailDomainStatus["notInitiated"] = "notInitiated";
    emailDomainStatus["active"] = "active";
    emailDomainStatus["disabled"] = "disabled";
    emailDomainStatus["processing"] = "processing";
})(emailDomainStatus = exports.emailDomainStatus || (exports.emailDomainStatus = {}));
var emailDomainTypes;
(function (emailDomainTypes) {
    emailDomainTypes["default"] = "default";
    emailDomainTypes["custom"] = "custom";
})(emailDomainTypes = exports.emailDomainTypes || (exports.emailDomainTypes = {}));
var emailSendBy;
(function (emailSendBy) {
    emailSendBy["localEmailClient"] = "localEmailClient";
    emailSendBy["tsEmailService"] = "tsEmailService";
})(emailSendBy = exports.emailSendBy || (exports.emailSendBy = {}));
var postMessageMethod;
(function (postMessageMethod) {
    postMessageMethod["IFrame"] = "IFrame";
})(postMessageMethod = exports.postMessageMethod || (exports.postMessageMethod = {}));
var SalesForceAuthMethod;
(function (SalesForceAuthMethod) {
    SalesForceAuthMethod["UserPassword"] = "UserPassword";
    SalesForceAuthMethod["JWT"] = "JWT";
})(SalesForceAuthMethod = exports.SalesForceAuthMethod || (exports.SalesForceAuthMethod = {}));
var PendingAccountStatus;
(function (PendingAccountStatus) {
    PendingAccountStatus["Expired"] = "Expired";
    PendingAccountStatus["Pending"] = "Pending";
    PendingAccountStatus["Approved"] = "Approved";
    PendingAccountStatus["Rejected"] = "Rejected";
    PendingAccountStatus["Revoked"] = "Revoked";
})(PendingAccountStatus = exports.PendingAccountStatus || (exports.PendingAccountStatus = {}));
var PendingAccountTypes;
(function (PendingAccountTypes) {
    PendingAccountTypes["Salesforce"] = "Salesforce";
    PendingAccountTypes["Live"] = "Live";
})(PendingAccountTypes = exports.PendingAccountTypes || (exports.PendingAccountTypes = {}));
var salesforceAccountType;
(function (salesforceAccountType) {
    salesforceAccountType["Regular"] = "regular";
    salesforceAccountType["SDO"] = "sdo";
})(salesforceAccountType = exports.salesforceAccountType || (exports.salesforceAccountType = {}));
var ExternalPackageType;
(function (ExternalPackageType) {
    ExternalPackageType["VRA"] = "VRA";
    ExternalPackageType["TSVE"] = "TSVE";
})(ExternalPackageType = exports.ExternalPackageType || (exports.ExternalPackageType = {}));
exports.SalesforceEnvironmentTypes = {
    production: { name: 'Production Organizations', env: 'production' },
    sandbox: { name: 'Sandbox organizations', env: 'test' }
};
var LivePointerSupportedOS;
(function (LivePointerSupportedOS) {
    LivePointerSupportedOS["Windows"] = "windows";
    LivePointerSupportedOS["MacOS"] = "mac";
})(LivePointerSupportedOS = exports.LivePointerSupportedOS || (exports.LivePointerSupportedOS = {}));
var ReferralConfigurations;
(function (ReferralConfigurations) {
    ReferralConfigurations["american"] = "US and Canada app";
    ReferralConfigurations["european"] = "Rest of the world app";
})(ReferralConfigurations = exports.ReferralConfigurations || (exports.ReferralConfigurations = {}));
var redirectTypes;
(function (redirectTypes) {
    redirectTypes["none"] = "NONE";
    redirectTypes["default"] = "DEFAULT";
    redirectTypes["unbrandedDefault"] = "UNBRANDED_DEFAULT";
    redirectTypes["url"] = "URL";
})(redirectTypes = exports.redirectTypes || (exports.redirectTypes = {}));

//# sourceMappingURL=account.constants.js.map
